import { render, staticRenderFns } from "./EipTextarea.vue?vue&type=template&id=6636273b&scoped=true&"
import script from "./EipTextarea.vue?vue&type=script&lang=js&"
export * from "./EipTextarea.vue?vue&type=script&lang=js&"
import style0 from "./EipTextarea.vue?vue&type=style&index=0&id=6636273b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636273b",
  null
  
)

export default component.exports